import { render, staticRenderFns } from "./TriaseCard.vue?vue&type=template&id=eb51c44e&scoped=true"
import script from "./TriaseCard.vue?vue&type=script&lang=js"
export * from "./TriaseCard.vue?vue&type=script&lang=js"
import style0 from "./TriaseCard.vue?vue&type=style&index=0&id=eb51c44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb51c44e",
  null
  
)

export default component.exports